<template>
    <div class="body scroll_bar">
        <Loadmore style="min-height:100%" :auto-file="false" :top-status.sync="loadStatus" :top-method="loadHistory"
            ref="loadmore">
            <div slot="top" class="mint-loadmore-top">
                <span v-show="!loadStatus">{{ $t('getHistory') }}</span>
                <span v-show="loadStatus === 'loading'">{{ $t('loading') }}</span>
                <span v-show="loadStatus === 'end'">{{ $t('noHistory') }}</span>
            </div>
            <div v-if="initData.noticeMode" class="notice" @mouseenter="onStop" @mouseleave="onStart" @touchstart="onStop"
                @touchend="onStart">
                <span class="icon">NEWS</span>

                <span class="icon2"></span>
                <div ref="notice" style="margin-top: -15px;">{{ noticeText }}
                </div>
            </div>
            <div style="padding-top: 10px">
                <div class="message_item" v-for="item in chatList" :key="item.date" v-if="!item.recallFlag"
                    :class="item.senderType === 2 || item.senderType === 3 ? 'left' : item.senderType === 1 ? 'right' : 'center'">
                    <!--            机器人3 或者  人工客服2-->
                    <div v-if="item.senderType === 2 || item.senderType === 3" class="left_message">
                        <div class="face" v-if="item.msgType !== 99">
                            <img :src="PCimg">
                        </div>
                        <div class="message">
                            <div class="send_name" v-if="item.msgType !== 99"><a class="bluefont">{{ item.senderName }}</a>
                                {{
                                    formDate(item.msgTime, 'MM-dd hh:mm:ss')
                                }}
                            </div>
                            <!--  各种消息类型 -->
                            <div v-if="(item.msgType === 1 || !item.msgType) && item.docPattern !== 1" class="text_message">
                                <div >{{item.msgContent}}</div>
                                <div v-html="item.answer"></div>
                                <div class="guide" :style="{ color: initData.kitBgcolor }" @click="guideSend(guide)"
                                    v-for="(guide, $index) in item.suggestList" v-html="$index + 1 + '.' + guide.question">
                                </div>

                            </div>
                              <div v-if="(item.msgType === 50)" class="text_message">
                                 <div v-html="item.msgContent"></div>
                             </div>

                            <!--  ceshi -->

                            <!-- <div class="menubar nopadding" v-if="
                                (item.msgType === 11 || !item.msgType) && item.docPattern !== 1
                            ">
                                <div class="business">
                                    <div class="business-list-item" v-for="item in menubar" :key="item.id">
                                        <div class="business-list-inner-item" @click.stop="chooseMenu(item)">
                                            <div class="item-img"><img :src="item.titleImgUrl">
                                            </div>
                                            <div class="item-text">{{ item.businessLineName }}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div v-if="
                                (item.msgType === 11 || !item.msgType) && item.docPattern !== 1
                            " class="text_message nopadding">

                                <el-row class="w400" :class="guideType == 2 ? '' : 'h240'">
                                    <el-col :span="4">
                                        <img class="not-scroll-img" :src="imgUrl" style="height: 100%;">
                                    </el-col>
                                    <el-col :span="20" class="pl10">
                                        <div class="type1" v-if="guideType == 2">
                                            <el-tabs v-model="activeName">
                                                <el-tab-pane :key="item.id" v-for="item in List" :label="item.groupName"
                                                    :name="item.id">
                                                    <div v-for="(guide, $index) in item.faqDocRespVos" :key="guide.id">
                                                        <div v-if="(Math.ceil(($index + 1) / 5) == activeIndex)"
                                                            @click.stop="chooseSend(guide)" class="guide"
                                                            v-html="guide.questionName"></div>
                                                    </div>
                                                    <div class="refreshbtn" @click.stop="refreshFn(item.faqDocRespVos)"
                                                        v-if="(item.faqDocRespVos.length > 5)"> <i
                                                            class="el-icon-refresh">换一批</i>
                                                    </div>
                                                </el-tab-pane>

                                            </el-tabs>

                                        </div>


                                        <div v-if="guideType == 1">
                                            <div class="guide" :key="guide.id" v-for="(guide, $index) in List">
                                                <div v-if="(Math.ceil(($index + 1) / 5) == activeIndex)"
                                                    @click.stop="chooseSend(guide)" v-html="guide.questionName"> </div>
                                            </div>
                                            <div class="refreshbtn" @click="refreshFn(List)" v-if="(List.length > 5)">
                                                <i class="el-icon-refresh">换一批</i>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div> -->


                            <!--  ceshi -->
                            <div class="menubar nopadding" v-if="
                                (item.msgType === 99) && item.docPattern !== 1 && item.menubar && item.menubar.length > 0 && item.showType == 3
                            ">
                                <div class=" ">
                                    <div class="business-list-item" v-for="(it, index) in item.menubar" :key="it.id">
                                        <div :class="actM == it.id ? 'business-list-inner-item actM' : 'business-list-inner-item'"
                                            @click="chooseMenu(it)">
                                            <div class="item-img">
                                                <img :src="it.imgUrl" v-if="actM !== it.id">
                                                <img src="../../../static/image/damo/1.png" v-else-if="index == 0">
                                                <img src="../../../static/image/damo/2.png" v-else-if="index == 1">
                                                <img src="../../../static/image/damo/3.png" v-else-if="index == 2">
                                                <img src="../../../static/image/damo/4.png" v-else-if="index == 3">
                                            </div>
                                            <div class="item-text">{{ it.name }}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div v-if="
                                (item.msgType === 99) && item.docPattern !== 1
                            " class="text_message nopadding">

                                <el-row class="w400" :class="type == 2 ? '' : 'h240'">
                                    <!-- <el-col :span="4">
                                        <img class="not-scroll-img" src="../../../static/image/wantToAsk.png"
                                            style="height: 100%;">
                                    </el-col> -->
                                    <el-col :span="24" class="pl10">
                                        <div class="type1" v-if="type == 2">
                                            <el-tabs v-model="activeName">
                                                <el-tab-pane :key="item.id" v-for="item in List" :label="item.name"
                                                    :name="item.id">
                                                    <div v-for="(guide, $index) in item.list" :key="guide.id">
                                                        <div v-if="(Math.ceil(($index + 1) / 5) == activeIndex)"
                                                            class="guide" @click="chooseSend(guide)">
                                                            <p class="black" v-html="guide.questionName"></p>
                                                            <i class="fr el-icon-arrow-right"></i>
                                                        </div>


                                                    </div>
                                                    <div class="refreshbtn" @click="refreshFn(item.list)"
                                                        v-if="(item.list && item.list.length > 5)"> <i
                                                            class="el-icon-refresh">换一批</i>
                                                    </div>
                                                </el-tab-pane>

                                            </el-tabs>

                                        </div>


                                        <div v-if="type == 1">
                                            <div class="guide" :key="guide.id" v-for="(guide, $index) in List">
                                                <div v-if="(Math.ceil(($index + 1) / 5) == activeIndex)"
                                                    @click="chooseSend(guide)">
                                                    <p class="black" v-html="guide.questionName"></p>
                                                    <i class="fr el-icon-arrow-right"></i>
                                                </div>
                                            </div>
                                            <div class="refreshbtn" @click="refreshFn(List)" v-if="(List.length > 5)">
                                                <i class="el-icon-refresh">换一批</i>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>

                            </div>
                            <div v-if="
                                (item.msgType === 99) && item.docPattern !== 1 && 0
                            " class="banner nopadding" @click="gotodamo">
                                <p class="name">大摩现代服务混合</p>
                                <p class="mark">科技改变生活</p>
                            </div>

                            <!--  多轮问题展示 -->
                            <div v-if="(item.msgType === 1 || item.msgType === 3 || !item.msgType) && item.docPattern === 1"
                                class="text_message">
                                <div v-html="item.answer" v-if="item.docNode.nodeType !== 3"></div>
                                <iframe :src="item.answer" frameborder="0" v-if="item.docNode.nodeType === 3"></iframe>
                                <div class="guide series" @click="seriesProblem(guide)" v-if="item.docNode.nodeType === 1"
                                    v-for="(guide, $index) in item.docNode.itemList" v-html="guide.itemContent"></div>
                            </div>
                            <div v-if="item.msgType === 2" class="image_message">
                                <img :src="item.msgContent" :alt="item.fileName" @click="showLargeImage(item)">
                            </div>
                            <!--              机器人的富文本-->
                            <div v-if="item.msgType === 3 && item.senderType === 3 && item.docPattern !== 1"
                                class="text_message">
                                <div v-html="item.msgContent"></div>
                                <div class="guide" :style="{ color: initData.kitBgcolor }"
                                    v-for="(guide, $index) in JSON.parse(item.robotSuggest)" @click="guideSend(guide)"
                                    v-html="$index + 1 + '.' + guide.question"></div>
                            </div>
                            <!--              人工富文本-->
                            <div v-if="item.msgType === 3 && item.senderType === 2 && item.docPattern !== 1"
                                class="card_message" @click="goCardDetail(item)">
                                <img :src="JSON.parse(item.msgContent).picture">
                                <div class="info">
                                    <div class="title">{{ JSON.parse(item.msgContent).title }}</div>
                                    <div class="desc">{{ JSON.parse(item.msgContent).desc }}</div>
                                    <div class="price">{{ JSON.parse(item.msgContent).price }}</div>
                                </div>
                            </div>

                            <div v-if="item.msgType === 4" class=" file_message" @click="chooseFile(item)">
                                <div class="file_icon">
                                    <!-- <svg t="1617682401274" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" p-id="2051" width="32" height="32">
                                        <path
                                            d="M597.333333 85.333333H256c-46.933333 0-84.906667 38.4-84.906667 85.333334L170.666667 853.333333c0 46.933333 37.973333 85.333333 84.906666 85.333334H768c46.933333 0 85.333333-38.4 85.333333-85.333334V341.333333l-256-256z m85.333334 682.666667H341.333333v-85.333333h341.333334v85.333333z m0-170.666667H341.333333v-85.333333h341.333334v85.333333z m-128-213.333333V149.333333L789.333333 384H554.666667z"
                                            fill="#bfbfbf" p-id="2052"></path>
                                    </svg> -->

                                    <i class="el-icon-document"></i>
                                </div>
                                <div class="file_name">
                                    <div>{{ item.fileName.substring(0, 20) }}</div>
                                    <!--                  <div class="file_size">-->
                                    <!--                    <span v-if="item.size">{{ item.size }}k</span>-->
                                    <!--                    <a :href="item.msgContent">下载</a>-->
                                    <!--                  </div>-->
                                </div>

                            </div>
                            <div v-if="item.msgType === 7" class="goods_message">
                                <div class="goods_info" @click="goCardDetail(item)">
                                    <div class="goods_image">
                                        <img :src="JSON.parse(item.msgContent).imgUrl" alt="">
                                    </div>
                                    <div class="goods_detail">
                                        <div class="goods_title">{{ JSON.parse(item.msgContent).title }}</div>
                                        <div class="goods_desc">{{ JSON.parse(item.msgContent).describe }}</div>
                                        <div class="goods_label">{{ JSON.parse(item.msgContent).label }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.msgType === 8" class="order_message">
                                <div class="goods_info">
                                    <div class="goods_image">
                                        <img :src="JSON.parse(item.msgContent).imgUrl" alt="">
                                    </div>
                                    <div class="goods_detail">
                                        <div class="goods_title">{{ JSON.parse(item.msgContent).title }}</div>
                                        <div class="goods_desc">{{ JSON.parse(item.msgContent).describe }}</div>
                                        <div class="card_status">
                                            <span class="order_status">
                                                {{ JSON.parse(item.msgContent).orderStatus }}
                                            </span>
                                            <span class="time">
                                                {{ JSON.parse(item.msgContent).orderTime }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div v-if="item.docId && initData.commentDocMode">
                                <span>{{ $t('thump') }}</span>
                                <span>{{ $t('top') }}</span>
                            </div> -->
                        </div>
                    </div>
                    <p class="guide series  fl ml10" @click="TransferBtn" v-show="item.showTransferBtn">
                        <i class="el-icon-user"></i>
                        {{
                            $t("transform")
                        }}
                    </p>
                    <!-- 用户-->
                    <div v-if="item.senderType === 1" class="right_message">

                        <div class="message">
                            <div class="send_name"> {{ formDate(item.msgTime, 'MM-dd hh:mm:ss') }} </div>
                            <!--{{ item.senderName }}-->
                            <!--  各种消息类型              -->
                            <div v-if="item.msgType === 1" class="text_message" :style="{
                                background: `#00A1E2`,
                                color: `#FFFFFF`
                            }">{{item.msgContent}}</div>
                            <div v-if="item.msgType === 2" class=" image_message">
                                <img :src="item.msgContent" :alt="item.name" @click="showLargeImage(item)">
                            </div>
                            <div v-if="item.msgType === 3" class="card_message" @click="goCardDetail(item)">
                                <img :src="JSON.parse(item.msgContent).picture">
                                <div class="info">
                                    <div class="title">{{ JSON.parse(item.msgContent).title }}</div>
                                    <div class="desc">{{ JSON.parse(item.msgContent).desc }}</div>
                                    <div class="price">{{ JSON.parse(item.msgContent).price }}</div>
                                </div>
                            </div>
                            <div v-if="item.msgType === 4" class=" file_message" @click="chooseFile(item)">
                                <div class="file_icon">
                                    <!-- <svg t="1617682401274" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" p-id="2051" width="32" height="32">
                                        <path
                                            d="M597.333333 85.333333H256c-46.933333 0-84.906667 38.4-84.906667 85.333334L170.666667 853.333333c0 46.933333 37.973333 85.333333 84.906666 85.333334H768c46.933333 0 85.333333-38.4 85.333333-85.333334V341.333333l-256-256z m85.333334 682.666667H341.333333v-85.333333h341.333334v85.333333z m0-170.666667H341.333333v-85.333333h341.333334v85.333333z m-128-213.333333V149.333333L789.333333 384H554.666667z"
                                            fill="#bfbfbf" p-id="2052"></path>
                                    </svg> -->

                                    <i class="el-icon-document"></i>
                                </div>
                                <div class="file_name">
                                    <div>{{ item.fileName.substring(0, 20) }}</div>
                                    <!--                  <div class="file_size">-->
                                    <!--                    <span v-if="item.size">{{ item.size }}k</span>-->
                                    <!--                    <a :href="item.msgContent">下载</a>-->
                                    <!--                  </div>-->
                                </div>
                            </div>
                            <div v-if="item.msgType === 5" class=" audio_message">
                                <audio :src="item.msgContent" controls></audio>
                            </div>
                            <div v-if="item.msgType === 6" class=" video_message">
                                <video :src="item.msgContent" controls></video>
                            </div>
                            <div v-if="item.msgType === 7" class="goods_message">
                                <div class="goods_info" @click="goCardDetail(item)">
                                    <div class="goods_image">
                                        <img :src="JSON.parse(item.msgContent).imgUrl" alt="">
                                    </div>
                                    <div class="goods_detail">
                                        <div class="goods_title">{{ JSON.parse(item.msgContent).title }}</div>
                                        <div class="goods_desc">{{ JSON.parse(item.msgContent).describe }}</div>
                                        <div class="goods_label">{{ JSON.parse(item.msgContent).label }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.msgType === 8" class="order_message">
                                <div class="goods_info" @click="goCardDetail(item)">
                                    <div class="goods_image">
                                        <img :src="JSON.parse(item.msgContent).imgUrl" alt="">
                                    </div>
                                    <div class="goods_detail">
                                        <div class="goods_title">{{ JSON.parse(item.msgContent).title }}</div>
                                        <div class="goods_desc">{{ JSON.parse(item.msgContent).describe }}</div>
                                        <div class="card_status">
                                            <span class="order_status">
                                                {{ JSON.parse(item.msgContent).orderStatus }}
                                            </span>
                                            <span class="time">
                                                {{ JSON.parse(item.msgContent).orderTime }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <i v-if="item.status === 'loading'" class="el-icon-loading status"></i>
                            <i v-if="item.status === 'failed'" class="el-icon-warning status"></i>
                        </div>
                        <div style=" margin-left: 8px;" class="face">
                            <img :src="Uimg">
                        </div>
                    </div>
                    <!--            系统消息-->
                    <div v-if="item.senderType === 4 || (!item.senderType && !item.senderName && item.msgType != 998)"
                        class="system_message">
                        <span v-if="item.clientType == 2" class="normal" v-html="item.msgContent"></span>
                        <span v-else-if="item.clientType != 1" :class="item.type === 1 ? 'normal' : 'bg'"
                            v-html="item.msgContent"></span>
                    </div>
                    <!--    超时信息-->
                    <div v-if="!item.senderType && item.senderName" class="left_message">
                        <div class="face" v-if="initData.avatar">
                            <img :src="item.faceUrl" /> {{ item.msgType }}
                        </div>
                        <div class="message">
                            <div class="send_name">{{ item.senderName }} {{ formDate(item.msgTime, 'MM-dd hh:mm:ss') }}
                            </div>
                            <div class="msg_div">
                                <div class="text_message">
                                    <div v-html="item.msgContent"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 商品卡片-->
                    <div v-if="item.msgType === 'card'" class="card_center">
                        <div class="card_message">
                            <img :src="item.picture">
                            <div class="info">
                                <div class="title">{{ item.title }}</div>
                                <div class="desc">{{ item.desc }}</div>
                                <div class="price">{{ item.price }}</div>
                                <span class="send_card" @click="sendObj(item)">发送客服</span>
                            </div>
                        </div>
                    </div>
                </div>
                <span v-scroll-bottom="scrollBottom" class="scroll_auto scroll-bottom scroll_iframe_auto_bottom"></span>
            </div>
        </Loadmore>
        <div class="shade" v-if="btRecoding" catchtouchmove="ture">
            <div class="blackBoxSpeak" v-if="blackBoxSpeak">
                <div>
                    <img src="../../../static/image/lz.png" />
                </div>
                <p class="blackBoxSpeakConent">手指上划，取消录制</p>
            </div>
            <div class="blackBoxPause" v-else>
                <img src="../../../static/image/qxlz.png" />
                <p class="blackBoxSpeakConent" style="color:red">松开手指，取消录制</p>
            </div>
        </div>

        <Popup style="width:100%;background: none;background: transparent;" v-model="showImage">
            <img @click="showImage = !showImage" :src="largeImageUrl" class="large_image" alt="">
        </Popup>
    </div>
</template>

<script>
import language from "../../store/index";
import { Loadmore } from "mint-ui";
import chatApi from "../methods";
import store from "../../store/index";
import { Popup } from "mint-ui";
import bus from "@/utils/bus";

import damo1 from "../../../static/image/damo1.png";
import damo2 from "../../../static/image/damo3.png";
export default {
    name: "Body",
    data() {
        return {
            timeOutId: null,
            showImage: false,
            largeImageUrl: "",
            noticeText: "",
            btRecoding: false,
            blackBoxSpeak: false,
            activeName: '',
            activeIndex: 1,
            menubar: [],
            type: 2,
            List: [],
            PCimg: damo1,
            Uimg: damo2,
            actM: ''
        };
    },
    components: {
        Loadmore,
        Popup,
    },
    mounted() {
        bus.$on("closeScreen", (res) => {
            this.btRecoding = res.btRecoding;
            this.blackBoxSpeak = res.blackBoxSpeak;
        });
        setTimeout(() => {
            document.querySelector(".message_item").onclick = function (e) {
                const link = e.target.getAttribute("data-link");
                if (link) {
                    window.open(link);
                }
            };
        }, 1000)

    },
    methods: {
        onStop() {
            if (!!this.$refs) {
                this.$refs.notice.style.animationPlayState = 'paused';
            }
        },
        onStart() {
            if (!!this.$refs) {
                this.$refs.notice.style.animationPlayState = 'running';
            }
        },
        formDate(value, fmt) {
            if (!value) {
                return ''
            }
            fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
            if (value && value < 10000000000) {
                value = value * 1000;
            }

            let getDate = new Date(value * 1);
            let o = {
                'M+': getDate.getMonth() + 1,
                'd+': getDate.getDate(),
                'h+': getDate.getHours(),
                'm+': getDate.getMinutes(),
                's+': getDate.getSeconds(),
                'q+': Math.floor((getDate.getMonth() + 3) / 3),
                'S': getDate.getMilliseconds()
            };
            // if (/(y+)/.test(fmt)) {
            //     fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
            // }
            // for (let k in o) {
            //     if (new RegExp('(' + k + ')').test(fmt)) {
            //         fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            //     }
            // }
            if (o["m+"] < 10) {
                o["m+"] = '0' + o["m+"]
            }
            fmt = o["M+"] + '月' + o["d+"] + '日' + o["h+"] + ':' + o["m+"];
            return fmt;
        },
        loadHistory() {
            if (this.loadStatus !== "end") {
                this.$refs.loadmore.onTopLoaded();
                store.dispatch("setLoadingStatus", "loadStart");
                chatApi.getHistoryList({ pageSize: 20, maxTime: 0 });
            }
        },
        chooseFile(file) {
            console.log(file);
            window.open(file.msgContent, "_blank");
        },
        // 点击引导问题
        guideSend(guide) {
            const obj = {
                docId: guide.docId,
                click: 1,
                msgContent: guide.question,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
            };
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            chatApi.sendMessage(obj);
        },
        // 点击多轮问题
        seriesProblem(guide) {
            const obj = {
                docId: guide.docId,
                itemId: guide.itemId,
                click: 1,
                msgContent: guide.itemContent,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
            };
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            chatApi.sendMessage(obj);
        },
        // 点击技能组
        selectGroup(group) {
            this.$store.dispatch("setShowChannelGroup", false);
            chatApi.transfer(group);
        },
        //跳转到商品详情
        goCardDetail(card) {
            try {
                let obj = JSON.parse(card.msgContent);
                let url = obj.url || obj.fromUrl
                window.open(url, "_blank");
            } catch (e) {
            }
        },
        // 图片点击放大
        showLargeImage(img) {
            if (img.msgContent) {
                this.showImage = true;
                this.largeImageUrl = img.msgContent;
            }
        },
        chooseMenu(item) {

            this.actM = item.id
            if (item.type == 2) {
                this.activeName = item.faqGrouplist[0].id;
                this.List = item.faqGrouplist
            } else if (item.type == 1) {
                this.List = item.questionList;
            } else {
                window.open(item.labelLink, "_blank");
                return;
            };
            this.type = item.type;
            // this.imgUrl = item.imgUrl;
            this.activeIndex = 1;
        },
        refreshFn(item) {

            this.activeIndex = this.activeIndex < (Math.ceil(item.length / 5)) ? this.activeIndex + 1 : 1;

        },
        chooseSend(row) {
            const obj = {
                click: 1,
                msgContent: row.questionName,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
                docId: row.docId,
            };
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            chatApi.sendMessage(obj);
        },
        TransferBtn() {
            chatApi.chatForm();
        },
        //发送对象 商品  订单 。。。
        sendObj(obj) {
            chatApi.sendJson(obj)
        },
        gotodamo() {
            window.open('https://www.msfunds.com.cn/', "_blank");
        },
    },
    computed: {
        chatList() {
            console.log(this.$store.state.chatList)
            return this.$store.state.chatList;
        },
        scrollBottom() {
            return this.$store.state.scrollBottom;
        },
        loadStatus() {
            return this.$store.state.loadStatus;
        },
        agentTyping() {
            if (this.$store.state.agentTyping) {
                document.title = "客服正在输入...";
            }
            if (this.timeOutId) {
                clearTimeout(this.timeOutId);
            }
            this.timeOutId = setTimeout(() => {
                // document.title = '用户咨询';
                document.title = this.$store.state.initData.titleDesc || this.$t('userQuestion');
            }, 1200);
        },
        initData() {
            console.log(this.$store.state.initData.avatar)

            if (this.$store.state.initData.faq) {
                var content = JSON.parse(this.$store.state.initData.faq.showContent);
                if (this.$store.state.initData.faq.showType == 3) {
                    this.actM = content[0].id
                    if (content[0].type == 1) {
                        this.List = content[0].questionList || [];
                    } else if (content[0].type == 2) {
                        this.List = content[0].faqGrouplist || [];
                    }
                    this.type = content[0].type
                } else if (this.$store.state.initData.faq.showType == 2) {
                    this.List = content;
                    this.type = 2;
                    this.activeName = content[0].id;
                } else {
                    this.List = content;
                    this.type = 1;
                }

            }

            return this.$store.state.initData;
        },


    },
    watch: {
        activeName() {
            this.activeIndex = 1;
        },
        chatList() {
            return this.$store.state.chatList;
        },
        scrollBottom() {
            setTimeout(() => {
                document.getElementsByClassName("scroll-bottom")[0].scrollIntoView();
            }, 100);
        },
        loadStatus() {
            return this.$store.state.loadStatus;
        },
        agentTyping() {
            return this.$store.state.agentTyping;
        },
        initData() {
            console.log(this.$store.state.initData.avatar)

            if (this.$store.state.initData.noticeMode && this.$store.state.initData.noticeMsg) {
                const div = document.createElement('div')
                div.innerHTML = this.$store.state.initData.noticeMsg
                this.noticeText = div.textContent || div.innerText;
                setTimeout(() => {
                    let time = parseInt(this.noticeText.length / 9).toFixed(0) || 30
                    if (time < 10) time = 30
                    if (!!this.$refs) {
                        this.$refs.notice.style.animationDuration = ` ${time}s `;
                    }
                }, 20)
            }
            return this.$store.state.initData;
        },
    },
    directives: {
        // 发送消息后滚动到底部
        "scroll-bottom"(el) {
            setTimeout(() => {
                // el.scrollIntoView()
            }, 100);
        },
    },
};
</script>
<style scoped>
.body {
    background: #ffffff;
}

.notice {
    padding: 6px 0;
    background: #EAF9FF;
    text-align: left;
    color: #563c3c;
    font-size: 13px;
    width: 100%;
    position: relative;
    line-height: 15px;
    overflow: hidden;
    border-left: 13px solid #EAF9FF;
}

.notice .icon {
    display: inline-block;
    background-color: #C7B160;
    width: 46px;
    height: 16px;
    vertical-align: middle;
    text-align: center;
    color: #fff;
    background-size: 100% 100%;
    /* background-image: url("../../../static/image/notice.png"); */
    position: relative;
    z-index: 9;
    font-size: 12px;
    line-height: 16px;
}

.notice>div {
    display: inline-block;
    vertical-align: middle;
    animation: 14s move linear infinite normal;
    white-space: nowrap;
}

@keyframes move {
    0% {
        transform: translateX(320px);
        -webkit-transform: translateX(320px);
    }

    100% {
        transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
    }
}

.card_center {
    text-align: center;
}

.card_center .card_message {
    margin: 0 auto;
    border-radius: 10px;
    position: relative;

}

.card_center .send_card {
    position: absolute;
    bottom: 10px;
    right: 12px;
    padding: 2px 4px;
    font-size: 12px;
    border: 1px solid #00A1E2;
    border-radius: 4px;
    color: #00A1E2;

}

.notice p {
    margin: 2px;
}

.scroll_auto {
    height: 2px;
    display: block;
}

.message {
    position: relative;
    max-width: 100%;
    word-break: break-word;
}

.message .status {
    position: absolute;
    /*left: -19px;*/
    font-size: 16px;
    bottom: 0;
    color: #999;
}

.message .el-icon-warning {
    color: red;
}

.image_message,
.audio_message,
.video_message {
    max-width: 100%;
}

.audio_message audio,
.video_message video {
    max-width: 100%;
}

.image_message img {
    width: auto;
    max-width: 100px;
}

.guide {
    line-height: 30px;
}

.right_message {
    max-width: 79%;
    overflow: hidden;
}

.file_message {
    display: inline-block;
    padding: 8px;
    background: #fff;
    border-radius: 5px;
}

.file_message div {
    display: inline-block;
    vertical-align: middle;
}

.file_name {
    max-width: 300px;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #0AA4E2;
}

.el-icon-document {
    color: #0AA4E2;
    font-size: 36px;
}

.large_image {
    width: auto;
    max-width: 90%;
}

.card_message {
    border: 1px solid #e6e6e6;
    padding: 15px;
    cursor: pointer;
    border-radius: 0 10px 10px 10px;
}

.right_message .card_message {
    border-radius: 10px 0 10px 10px;
}

.card_message img {
    width: 65px;
    height: 65px;
    vertical-align: middle;
}

.card_message .info {
    display: inline-block;
    vertical-align: middle;
    width: 140px;
    margin: 0 10px;
    height: 65px;
}

.info .title,
.price {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
}

.info .title {
    font-size: 14px;
    font-weight: 600;
}

.info .desc {
    font-size: 12px;
    color: #666;
    text-align: left;
    height: 34px;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.info .price {
    color: #00A1E2;
    font-size: 12px;
}

.series {
    display: inline-block;
    padding: 0px 15px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    margin: 5px;
    overflow: hidden;
    max-width: 180px;
    height: 30px;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #00A1E2;
    background-color: white;
}

.series:active {
    background: #f3f3f3;
    color: #596788;
}

div.goods_message,
div.order_message {
    border: 1px solid #f0f0f0;
    padding: 7px;
    cursor: pointer;
    border-radius: 0 10px 10px;
}

.goods_info {
    background-color: #f9fafe;
    display: flex;
}

.goods_info>div,
.order_message>div {
    vertical-align: middle;
}

.goods_image img {
    width: 80px;
    height: 80px;
    display: inline-block;
    overflow: hidden;
    border-radius: 2px;
}

.goods_detail {
    width: 203px;
    height: 80px;
    display: inline-block;
}

.goods_title {
    font-size: 14px;
    font-weight: 600;
    text-overflow: ellipsis;
    overflow: hidden;
    height: 24px;
    text-align: left;
    white-space: nowrap;
    color: #333;
    padding: 1px 7px;
}

.goods_desc {
    text-align: left;
    line-height: 26px;
    font-size: 14px;
    padding: 0 7px;
    color: #666;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.goods_label {
    text-align: left;
    line-height: 30px;
    font-size: 16px;
    padding: 0 7px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #ff5756;
}

.card_status {
    font-size: 0;
}

.card_status span {
    vertical-align: middle;
    overflow: hidden;
    height: 18px;
}

.card_status .order_status {
    width: 70px;
    display: inline-block;
    text-align: left;
    color: #ebab28;
    font-size: 14px;
    padding-left: 8px;
}

.card_status .time {
    font-size: 12px;
    width: 116px;
    display: inline-block;
    text-align: right;
    color: #999;
    height: 12px;
    vertical-align: bottom;
}

.shade {
    z-index: 998;
    position: absolute;
    top: 30%;
    left: 25%;
    background-color: rgba(129, 125, 125, 0.8);
    width: 50vw;
    height: 200px;
    border-radius: 16px;
}

.shade img {
    margin-top: 20px;
    width: 148 rpx;
    height: 246 rpx;
}

.shade .blackBoxSpeak,
.shade .blackBoxPause {
    width: 343 rpx;
    height: 343 rpx;
    border-radius: 24 rpx;
    margin: auto;
    padding: 32 rpx;
    position: relative;
    text-align: center;
    top: 188 rpx;
}

.shade .blackBoxSpeakConent {
    width: 100%;
    padding-top: 30px;
    color: #fff;
    text-align: center;
    margin: auto;
    border-radius: 16px;
}

.w400 {
    width: 94vw;
    height: 294px;
    position: relative;
}

.h240 {
    width: 94vw;
    height: 250px;
    position: relative;
}

.nopadding {
    padding: 0 !important;
}

.pl10 {
    padding-left: 10px;
}

.item-img {
    width: 36px;
    /* height: 36px; */
    margin-bottom: 10px;
}

.item-text {
    /* width: 56px;
    height: 22px;
    color: #161616;
    line-height: 22px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    text-align: center; */

    color: rgb(153, 153, 153);
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: undefined;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
}

.business-list-inner-item {
    cursor: pointer;
    width: 78px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgb(0 0 0 / 10%);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 5px 0 5px;
    margin: 0 4px;
    align-items: center;
    touch-action: pan-x;
}

.actM {
    background: #0AA4E2;
}

.actM .item-text {
    color: #ffffff;
}

.actM .item-img img {
    filter: drop-shadow(0px，0px, #fff);
}

.business-list-item {
    float: left;
    width: 78px;
    margin: 0 10px 10px 0;
}

.menubar {
    white-space: pre-line;
    color: #333333;
    line-height: 20px;
    font-size: 14px;
    text-align: left;
    display: block !important;
    ;
}

.type1 /deep/ .el-tabs__content {
    height: 238px;
}

.type1 /deep/ .el-tabs__nav-next {
    top: 14px
}

.type1 /deep/ .el-tabs__nav-prev {
    top: 14px
}

.refreshbtn {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin-bottom: 16px; */
    color: #a3a5a8;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    margin-top: 0;
}

.guide {
    margin: 10px 20px 0 20px;
}


.business {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    white-space: nowrap;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
}

.menubar {
    width: 94vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    overflow-y: hidden;
    overflow-x: scroll;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
}

.body {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.text_message {
    font-family: "Microsoft Yahei", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.black {
    color: #000;
    border-bottom: 1px solid #e5e5e5;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.white {
    background: #ffffff;
}

.fr {
    position: absolute;
    margin-top: -24px;
    margin-left: 80vw;
    color: #000;
}

.fl {
    float: left;
}

.ml10 {
    margin-left: 10px;
    border-radius: 10px;
}

.banner {
    display: block;
    width: 94vw;
    height: 65px;
    margin-top: 10px;
    border-radius: 4px;
    background: url("../../../static/image/banner.png");
    background-position: right;
    position: relative;
    user-select: none;
    cursor: pointer;
}

.banner .name {
    position: absolute;
    width: 112px;
    height: 21px;
    left: 6.12%;
    right: 61.22%;
    top: 15.25px;
    bottom: 29.75px;

    color: rgb(255, 255, 255);
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: undefined;
    line-height: 21px;
    letter-spacing: 0px;
    text-align: justify;
}

.banner .mark {
    position: absolute;
    width: 100px;
    height: 15px;
    left: 6.12%;
    right: 76.38%;
    top: 36.75px;
    bottom: 14.25px;

    opacity: 0.8;
    color: rgb(255, 255, 255);
    font-family: PingFang SC;
    font-size: 10px;
    font-weight: undefined;
    line-height: 15px;
    letter-spacing: 0px;
    text-align: justify;
}

.el-icon-refresh {
    line-height: 44px;
}

.guide:hover .black {
    color: #0AA4E2;
}

.guide:hover .fr {
    color: #0AA4E2;
}

.send_name {
    color: rgb(206, 203, 203);
}

.bluefont {

    color: rgb(127, 150, 164)
}

.icon2 {
    display: inline-block;
    background: #EAF9FF;
    width: 2px;
    height: 16px;
    vertical-align: middle;
    text-align: center;
    color: #fff;
    background-size: 100% 100%;
    position: relative;
    z-index: 9;
    font-size: 12px;
    line-height: 16px;
    margin-left: -4px;
    border-left: 13px solid #EAF9FF;
}
</style>



// WEBPACK FOOTER //
// src/components/h5/body.vue